import {
  Group,
  NumberInput,
  Text,
  TextInput,
  UnstyledButton,
  rem,
} from '@mantine/core';
import dayjs from 'dayjs';
import { dateFormat } from '@/index';
import { DateInput, type DateValue } from '@mantine/dates';
import { TbTrashXFilled } from 'react-icons/tb';
import { IconPlus } from '@tabler/icons-react';
import { BiSolidDownArrow } from 'react-icons/bi';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const CourseCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const handleCreateCourse = () => {
    const newCourse = {
      name: '',
      date: dayjs(new Date()).format(dateFormat),
    };

    form.insertListItem('courses', newCourse);
  };

  const handleDeleteCourse = (index: number) => {
    form.removeListItem('courses', index);
  };

  const showCourses = () => {
    return form.values.courses.length === 0 ? null : (
      <table className="mt-3">
        <thead>
          <tr>
            <th className="text-left">Název kurzu</th>
            <th className="text-left">Datum</th>
            <th className="text-left">Hodiny</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{courseRows}</tbody>
      </table>
    );
  };

  const courseRows = form.values.courses.map(
    (course: { name: string; date: string; hours: number }, index: number) => (
      <tr key={index}>
        <td style={{ width: '50%' }} className="pr-3 pt-3">
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            {...form.getInputProps(`courses.${index}.name`)}
          />
        </td>
        <td style={{ width: '25%' }} className="pr-3 pt-3">
          <DateInput
            variant="filled"
            radius="md"
            placeholder="note"
            rightSection={icon}
            valueFormat={dateFormat}
            value={dayjs(course.date, dateFormat).toDate()}
            onChange={(d: DateValue) => {
              const date: string = dayjs(d).format(dateFormat);
              form.setFieldValue(`courses.${index}.date`, date);
            }}
            error={form.getInputProps(`courses.${index}.date`).error}
            locale="cs"
          />
        </td>
        <td className="pr-3 pt-3">
          <NumberInput
            rightSection
            variant="filled"
            radius="md"
            placeholder="note"
            min={1}
            {...form.getInputProps(`courses.${index}.hours`)}
          />
        </td>
        <td className="pt-3">
          <UnstyledButton onClick={() => handleDeleteCourse(index)}>
            <TbTrashXFilled size="28" />
          </UnstyledButton>
        </td>
      </tr>
    )
  );

  return (
    <div>
      <Group justify="space-between" mt="xl">
        <Text fw={700} size="lg">
          Kurzy a školící akce
        </Text>
        <UnstyledButton onClick={handleCreateCourse}>
          <IconPlus />
        </UnstyledButton>
      </Group>
      {showCourses()}
    </div>
  );
};
